// Mirrors backend AREA_CATALOG in staff_assignments_service.py — keep in sync.
export const ALL_UNITS_VALUE = "__all__";

export const AREA_CATALOG = [
    { key: "unit", label: "Pod / Housing Unit", unitScoped: true, groups: ["custody"] },
    { key: "intake", label: "Intake", unitScoped: false, groups: ["custody", "care"] },
    { key: "booking", label: "Booking", unitScoped: false, groups: ["custody"] },
    { key: "transport", label: "Transport", unitScoped: false, groups: ["custody"] },
    { key: "release", label: "Release", unitScoped: false, groups: ["custody"] },
    { key: "infirmary", label: "Infirmary", unitScoped: false, groups: ["care"] },
    { key: "psych", label: "Psych / Mental Health Unit", unitScoped: false, groups: ["care"] },
    { key: "kite_triage", label: "Clinical Kite Triage", unitScoped: false, groups: ["care"] },
    { key: "med_pass", label: "Med Pass", unitScoped: true, groups: ["care"] },
];

export const AREA_LABEL = Object.fromEntries(AREA_CATALOG.map((a) => [a.key, a.label]));
export const UNIT_SCOPED_KEYS = AREA_CATALOG.filter((a) => a.unitScoped).map((a) => a.key);

export function areaDisplay(areaType, areaValue) {
    const label = AREA_LABEL[areaType] || areaType;
    if (UNIT_SCOPED_KEYS.includes(areaType)) {
        if (areaValue === ALL_UNITS_VALUE) return `${label} — All units`;
        return areaValue ? `${label} — ${areaValue}` : label;
    }
    return label;
}

// v1 planning horizon — matches backend MAX_SPAN_DAYS.
export const MAX_SPAN_DAYS = 28;

export function todayStr() {
    return new Date().toISOString().slice(0, 10);
}

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]; // 0=Mon..6=Sun, matches backend

export function addDaysStr(dateStr, days) {
    const d = new Date(dateStr + "T00:00:00");
    d.setDate(d.getDate() + days);
    return d.toISOString().slice(0, 10);
}

// Monday of the calendar week containing `dateStr` (default today).
export function mondayOf(dateStr = todayStr()) {
    const d = new Date(dateStr + "T00:00:00");
    const isoDow = (d.getDay() + 6) % 7; // 0=Mon..6=Sun
    return addDaysStr(dateStr, -isoDow);
}
